import { useNavigate } from 'react-router-dom'
import { Routes } from 'common/constants'
import { bridgeRequest } from 'common'
import { useAppContext } from 'contexts/app-context/hooks/useAppContext'
import { IRequestReportRequest } from 'common/types'

import { useMutation } from '@tanstack/react-query'

export type GerarLinkRelatorioRequest = {
  trackNumber: string
  dataRequest: string
  requestType: string
}

export const useRequestReportByEmail = (reportData: IRequestReportRequest) => {
  const { privacyCenterContent, isUSBranch } = useAppContext()

  const endpoint = privacyCenterContent?.endpoints?.reports?.requestReportByEmail

  const navigate = useNavigate()

  const {
    data: sendReport,
    isPending: isSendReportLoading,
    isError: isSendReportError,
    mutateAsync: sendReportFn,
  } = useMutation({
    mutationFn: () => {
      if (!endpoint) throw new Error('No endpoint available for useRequestReportByEmail')

      return bridgeRequest({
        endpoint,
        body: reportData,
        returnAllResponse: false,
        isUSBranch,
      })
    },
    onSuccess: () => navigate(Routes.SUCCESS_EMAIL_SENT),
  })

  return {
    sendReport,
    isSendReportLoading,
    isSendReportError,
    sendReportFn,
  }
}
